import { compose, path, pluck } from 'ramda'
import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { loadProfilesSequence } from '../profiles/factories'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'oneToOneActivities'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  loadProfiles,
]

export const findForList = [
  //
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: '1:1 activity saved', type: 'success' }),
  actions.redirectAfterSave,
  {
    connectionBoard: route.toRoot,
    profile: route.toPerson,
    list: route.toOneToOneActivities,
  },
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: '1:1 activity deleted', type: 'success' }),
  findForList,
]
